import profileImageUrl from '../assets/IMG_1986.jpg';

import { site } from './site';

export const siteBaseUrl = `https://${site.currentDomain}`;

export function absoluteUrl(path = '/') {
  if (/^https?:\/\//.test(path)) return path;

  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${siteBaseUrl}${normalizedPath}`;
}

export const defaultSocialImage = absoluteUrl(profileImageUrl);
